
import React from 'react';
import { Button } from "@/components/ui/button";
import { RefreshCw, Search } from 'lucide-react';
import { motion } from 'framer-motion';
import { NoMoreJobsProps } from '@/types/job';

export const NoMoreJobs: React.FC<NoMoreJobsProps> = ({ onReset, likedJobsCount }) => {
  return (
    <div className="flex flex-col items-center justify-center h-[450px] text-center">
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }} 
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="space-y-6"
      >
        <div className="h-24 w-24 mx-auto bg-gradient-to-br from-blue-50 to-gray-100 rounded-full flex items-center justify-center">
          <Search className="h-12 w-12 text-blue-400" />
        </div>
        
        <div className="space-y-2">
          <h3 className="text-xl font-semibold text-gray-800">No more jobs to show</h3>
          <p className="text-gray-500 max-w-sm mx-auto">
            You've gone through all available jobs in this category. {likedJobsCount > 0 ? `You've liked ${likedJobsCount} jobs.` : 'Try different search criteria or check back later.'}
          </p>
        </div>
        
        <div className="pt-4">
          <Button 
            onClick={onReset} 
            className="gap-2 bg-blue-600 hover:bg-blue-700 text-white"
          >
            <RefreshCw className="h-4 w-4" />
            Reset and Start Over
          </Button>
        </div>
      </motion.div>
    </div>
  );
};
